import React from 'react';
import styled from 'styled-components';
import { getIn } from 'seamless-immutable';
import { withRouter } from 'react-router';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';

const Link = styled.a`
  color: ${({ theme }) => theme.grey.dark};
  font-size: ${({ theme }) => theme.fontSize.xs};
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export const ReturnPolicy = ({ currentSku, history }) => {
  const isInternational = getIn(currentSku, ['offers', 'result', '0', 'currency']) === 'USD';

  if (isInternational) {
    return (
      <Link onClick={replaceUrlParams(history, '#modal-regras-mundo-b', false)}>
        conheça as regras sobre o Americanas Mundo
      </Link>
    );
  }

  return (
    <Link href="https://americanas.com.br/hotsite/atendimento_trocasedevolucoes" target="_blank">
      política de troca e devolução
    </Link>
  );
};

export default withRouter(ReturnPolicy);
